module.exports = __webpack_public_path__ + "img/1F509.0436241d.svg";